import { Link } from "react-router-dom";
import { Award, ShieldCheck, Star } from "lucide-react";

export function TrustBar({ className = "" }) {
  return (
    <div data-testid="trust-bar" className={`grid grid-cols-2 sm:grid-cols-4 gap-3 ${className}`}>
      {[
        { icon: ShieldCheck, title: "Registered Migration Agents", sub: "Four agents · One team" },
        { icon: Award, title: "MIA Member", sub: "Migration Institute of Australia" },
        { icon: Star, title: "Shamima Yasmin Anwar", sub: "Australia · New Zealand" },
        { icon: ShieldCheck, title: "Ethical & Personalised", sub: "Migration advice" },
      ].map((b, i) => (
        <div
          key={i}
          data-testid={`trust-badge-${i}`}
          className="flex items-center gap-3 bg-white border border-slate-200 px-3 py-3 sm:px-4 sm:py-3.5"
        >
          <b.icon className="h-5 w-5 text-[#C43A89] shrink-0" />
          <div>
            <div className="text-[10px] sm:text-[11px] font-bold tracking-widest text-[#29324A] uppercase leading-tight">
              {b.title}
            </div>
            <div className="text-xs text-slate-500 mt-0.5">{b.sub}</div>
          </div>
        </div>
      ))}
    </div>
  );
}

export function CTASection() {
  return null;
}

function CTASectionRemoved({ title = "Ready for the right migration advice?" }) {
  return (
    <section data-testid="cta-section" className="bg-[#29324A] text-white grain">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20 relative z-10">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          <div>
            <div className="text-[11px] font-bold tracking-[0.2em] text-[#C43A89] uppercase mb-4">
              Speak to a Registered Migration Agent
            </div>
            <h2 className="font-display text-3xl md:text-5xl tracking-tight leading-tight">
              {title}
            </h2>
            <p className="mt-5 text-slate-300 text-base md:text-lg max-w-xl">
              Confidential, ethical and personalised guidance from our team of Registered Migration Agents — Sydney, Melbourne &amp; Perth.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row md:flex-col gap-3 md:justify-self-end md:w-72">
            <Link to="/book-consultation" data-testid="cta-book-btn" className="bg-[#C43A89] hover:bg-[#a22b6e] text-white font-semibold py-4 px-6 text-center transition-colors btn-shimmer">
              Book a Consultation
            </Link>
            <Link to="/pr-assessment" data-testid="cta-pr-btn" className="bg-white text-[#29324A] hover:bg-slate-100 font-semibold py-4 px-6 text-center transition-colors">
              Start PR Assessment
            </Link>
            <Link to="/points-calculator" data-testid="cta-points-btn" className="border-2 border-white text-white hover:bg-white hover:text-[#29324A] font-semibold py-4 px-6 text-center transition-colors">
              Check Your Points
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export function PageHeader({ eyebrow, title, subtitle, image }) {
  return (
    <section data-testid="page-header" className="relative bg-[#F8F9FA] border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <div className="grid md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-8">
            {eyebrow && (
              <div className="text-[11px] font-bold tracking-[0.22em] text-[#C43A89] uppercase mb-5 flex items-center gap-3">
                <span className="brand-dot bg-[#C43A89]" />
                {eyebrow}
              </div>
            )}
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-[#29324A]">
              {title}
            </h1>
            {subtitle && (
              <p className="mt-6 text-lg text-slate-600 leading-relaxed max-w-2xl">
                {subtitle}
              </p>
            )}
          </div>
          {image && (
            <div className="md:col-span-4 hidden md:block">
              <img src={image} alt="" className="w-full h-64 object-cover" />
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export function Disclaimer({ children }) {
  return (
    <div data-testid="disclaimer" className="bg-[#F3F2F0] border-l-4 border-[#C43A89] p-5 text-sm text-slate-700 leading-relaxed">
      <strong className="text-[#29324A]">Disclaimer:</strong> {children}
    </div>
  );
}
